import { useState, useEffect } from "react";
import moment from "moment";
import { exportOrderReport } from "../services/reportService";

const ExportOrderReport = ({ search, dateRange }) => {
    const [busy, setBusy] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const exportData = async () => {
        const response = await exportOrderReport({ search, startDate, endDate });
        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const fileURL = URL.createObjectURL(blob);
        setBusy(false);
        const link = document.createElement("a");
        link.href = fileURL;
        const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
        link.download = `order-report_${timestamp}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        let start = dateRange[0]
            ? moment(dateRange[0]).format("YYYY-MM-DD")
            : null;
        let end = dateRange[1]
            ? moment(dateRange[1]).format("YYYY-MM-DD")
            : null;
        setStartDate(start);
        setEndDate(end);
    }, [dateRange]);

    return (
        <button
            onClick={() => {
                setBusy(true);
                exportData();
            }}
            className="btn btn-primary btn-md w-100 w-md-auto mb-2"
            disabled={busy === true ? true : false}
        >
            {busy === true ? (
                <span
                    className="spinner-border spinner-border-xs"
                    role="status"
                    aria-hidden="true"
                ></span>
            ) : (
                <>
                    <i className="ri-download-cloud-line me-1 fw-medium align-middle"></i>
                    Export
                </>
            )}
        </button>
    );
};

export default ExportOrderReport;